/**
 * Interpolate number of lectures
 *
 * @param numLectures - number of lectures to interpolate
 * @param i18n - `ninterpolate` function from @udemy/i18n
 */
export function getNumLecturesText(numLectures, {
  ninterpolate
}) {
  return ninterpolate('%s lecture', '%s lectures', numLectures);
}
//# sourceMappingURL=utilities.js.map